/**
 * REST client for LGPD self-service data deletion requests.
 *
 * The endpoint is mounted under /api/v1 (resolved by VITE_API_URL).
 * The user's tenant comes from the X-Tenant header set by the axios
 * interceptor; the user comes from the Bearer token.
 */

import { httpRequest } from "@/lib/axios";

export type DataDeletionRequestPayload = {
  reason_text?: string;
  confirmation: true;
};

export type DataDeletionRequestResponse = {
  message: string;
  data: {
    id: string;
    status: "pending" | "processing" | "completed" | "rejected";
    requested_at: string;
  };
};

/**
 * Submits a new LGPD data deletion request for the authenticated user.
 * Resolves with the response payload (including the protocol id) on
 * success and rejects with the underlying axios error on failure.
 */
export async function submitDataDeletionRequest(
  payload: DataDeletionRequestPayload
): Promise<DataDeletionRequestResponse> {
  const { data } = await httpRequest.post<DataDeletionRequestResponse>(
    "/data-deletion-requests",
    payload
  );
  return data;
}
